<template>
  <v-container fluid grid-list-md pt-0>
    <v-card>
      <v-form id="notifications">
        <v-expand-transition>
          <v-list class="py-0" subheader two-line>
            <v-subheader>{{$vuetify.t('$vuetify.NotificationSettings.allow')}}</v-subheader>
            <v-list-tile v-for="(option, key) in options" :key="key">
              <v-list-tile-action>
                <v-checkbox
                  :disabled="!options[key].enabled"
                  v-model="options[key].option"
                  >
                </v-checkbox>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-subtitle>
                  {{$vuetify.t('$vuetify.NotificationSettings.'+key)}}
                </v-list-tile-subtitle>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-expand-transition>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
  import api from '@/api'

  export default {
    name: 'ProfileSettings',
    data () {
      return {
        options: {
          'newSchoolIdea': { option: this.$store.getters.firebaseOptions.newSchoolIdea, enabled: true },
          'newClassIdea': { option: this.$store.getters.firebaseOptions.newClassIdea, enabled: true },
          'newSugestionYourIdea': { option: this.$store.getters.firebaseOptions.newSugestionYourIdea, enabled: true },
          'ideaPhaseChange': { option: this.$store.getters.firebaseOptions.ideaPhaseChange, enabled: true },
          'schoolTopicPhaseChange': { option: this.$store.getters.firebaseOptions.schoolTopicPhaseChange, enabled: true },
          'classTopicPhaseChange': { option: this.$store.getters.firebaseOptions.classTopicPhaseChange, enabled: true }
          // 'receiveDelegatedVote': { option: this.$store.getters.firebaseOptions.receiveDelegatedVote, enabled: true },
          // 'ideaQuorumPassed': { option: this.$store.getters.firebaseOptions.ideaQuorumPassed, enabled: false },
          // 'votedForYou': { option: this.$store.getters.firebaseOptions.votedForYou, enabled: true },
          // 'votingExpiring': { option: this.$store.getters.firebaseOptions.votingExpiring, enabled: true },
          // 'subjectReport': { option: this.$store.getters.firebaseOptions.subjectReport, enabled: false },
          // 'voteReceived': { option: this.$store.getters.firebaseOptions.voteReceived, enabled: false }
        }
      }
    },
    methods: {
      updateNotifications () {
        let notificationOptions = {}
        for (var key of Object.keys(this.options)) {
          notificationOptions[key] = this.options[key].option
        }
        api.user.updateUserConfig(this.$store.getters.userId, 'notifications', notificationOptions)
          .then(() => {
            this.$store.commit('SET_NOTIFICATION_OPTIONS', notificationOptions)
          })
      }
    },
    watch: {
      'options': {
        handler (val) {
          this.updateNotifications()
        },
        deep: true
      }
    }
  }
</script>

<style scoped>
  .noBSpace >>> .v-input__slot {
    margin-bottom: 0;
  }
</style>